/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { type MantineTheme, Tooltip as MantineTooltip, createTheme } from '@mantine/core';

import { colorToken, variablesToken } from '@fai/design-tokens';

import * as classes from './tooltip.css';

export const tooltipTheme = createTheme({
  components: {
    /** @url https://mantine.dev/core/tooltip/ */
    Tooltip: MantineTooltip.extend({
      defaultProps: {
        withArrow: false,
        multiline: true,
        transitionProps: { duration: 200 }, // TODO: discuss with design team
        variant: 'medium',
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- to be used
      vars: (_, props) => ({
        tooltip: {
          '--tooltip-bg': colorToken.color.bg.neutral.strong.hover,
          '--tooltip-radius': variablesToken.radius.sm,
        },
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- to be used
      classNames: (_, props) => {
        if (props.variant === 'small') {
          return {
            tooltip: classes.smallTooltip,
            arrow: classes.arrow,
          };
        }

        return {
          tooltip: classes.tooltip,
          arrow: classes.arrow,
        };
      },
    }),
  },
}) as MantineTheme;
